import React from "react"
import { observer, useLocalStore } from "mobx-react"
import { Button, Col, Flex, Row, Typography } from "antd"
import classNames from "classnames"

import { capitalizeFirstLetter } from "@src/shared/utils/capitalizeFirstLetter"
import {
  MerchStatsItemType,
  StatsPeriod,
} from "@src/widgets/merchantStats/classes/MerchantStats"
import { ChartRow, StatsPeriods } from "@src/widgets/merchantStats/constants"
import { StatsBlock } from "@src/widgets/merchantStats/ui/StatsBlock"
import { StatsChart } from "@src/widgets/merchantStats/ui/StatsChart"
import css from "./index.module.css"
type Props = {
  activePeriod: StatsPeriod
  blocks: MerchStatsItemType[]
  chart: ChartRow[]
}
export const MerchStats = observer(({ activePeriod, blocks, chart }: Props) => {
  return (
    <Flex gap={48} vertical>
      <Flex gap={16} vertical>
        <Flex>
          <Row gutter={[16, 24]}>
            {blocks.map((b) => (
              <Col key={b.type} span={8}>
                <StatsBlock block={b} />
              </Col>
            ))}
          </Row>
        </Flex>
      </Flex>

      <StatsChart data={chart} period={activePeriod} />
    </Flex>
  )
})
